import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import styles from './styles.module.scss'
import PromptCard from 'srcReact/components/common2/PromptCard'
import { profileActions } from 'srcReact/MyProfile/action'
import PromptListPopin from 'srcReact/components/popinsContent/PromptListPopin'
import Modal from 'srcReact/components/common2/Modal'
import { isMobileScreen } from 'srcReact/helpers/utils'
import MobileModal from 'srcReact/components/common2/MobileModal'
import MessengerMobile from 'srcReact/MessengerPage/MessengerMobile'
import Popup from 'reactjs-popup'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { organizationActions } from 'srcReact/OrganizationPage'

export default function PromptBlock({ title, block = 'myProfile', user, promptContainerRef, className }) {
  const { t } = useTranslation()
  const params = useParams()
  const dispatch = useDispatch()
  const {
    common: { isMobile, isNative },
    myProfile: {
      promptActions: { loading, id: idInProcess }
    },
    login: { user: loggedInUser }
  } = useSelector((state) => state)

  const [isPromptModalOpen, setIsPromptModalOpen] = useState(false)
  const [isReplyModalOpen, setIsReplyModalOpen] = useState(false)
  const [selectedPrompt, setSelectedPrompt] = useState(null)
  const [actionPrompt, setActionPrompt] = useState('add')
  const [likeTriggered, setLikeTriggered] = useState(false)
  const [deleteTriggered, setDeleteTriggered] = useState(false)
  const [modalData, setModalData] = useState({
    isShowUserModal: false,
    userId: 0,
    screen: ''
  })

  useEffect(() => {
    if (!loading && idInProcess > 0) {
      if (likeTriggered) {
        setLikeTriggered(false)
        const promptInModal = user.prompts?.prompts?.find((p) => p.id_prompt === idInProcess)
        if (selectedPrompt && promptInModal) {
          setSelectedPrompt(promptInModal)
        }
      }
      if (deleteTriggered) {
        setDeleteTriggered(false)
        callHeaderInfoForNative() //to update myprofile ctas
      }
    }
  }, [loading, idInProcess, likeTriggered, deleteTriggered])

  const callHeaderInfoForNative = () => {
    if (isNative) {
      const organizationId = getCurrentOrgId()
      dispatch(organizationActions.getHeaderInfo(organizationId))
    }
  }

  const handleLikeOrDislike = (p) => {
    if (user?.prompts?.editable === 0) {
      setLikeTriggered(true)
      let action = 'like'
      if (p?.likes?.users?.some((u) => u.id_user === loggedInUser?.id)) {
        action = 'dislike'
      }
      dispatch(profileActions.likeOrDislikePrompt(p?.id_prompt_user, action, p.id_prompt))
    }
  }

  const handleComment = (p, message) => {
    if (user?.prompts?.editable === 0) {
      setModalData({
        userId: user?.id,
        isShowUserModal: true,
        screen: 'messenger',
        message: message
      })
    }
  }

  const closeLightModal = () => {
    setModalData({
      selectedModalUser: null,
      isShowUserModal: false,
      screen: ''
    })
  }

  const handleNewPrompt = () => {
    setActionPrompt('add')
    setTimeout(() => setIsPromptModalOpen(true), 500)
  }

  const handleEdit = (p) => {
    setSelectedPrompt(p)
    setActionPrompt('edit')
    setTimeout(() => setIsPromptModalOpen(true), 500)
  }

  const handleDelete = (p) => {
    if (p) {
      setDeleteTriggered(true)
      dispatch(profileActions.deletePrompt(p.id_prompt_user, p.id_prompt))
    }
  }

  const closePromptModal = () => {
    setSelectedPrompt(null)
    setIsPromptModalOpen(false)
  }

  const openReplyModal = (prompt) => {
    setSelectedPrompt(prompt)
    setIsReplyModalOpen(true)
  }

  const closeReplyModal = () => {
    setSelectedPrompt(null)
    setIsReplyModalOpen(false)
  }

  let sortedPrompts = []
  if (user?.prompts?.prompts?.length >= 1) {
    sortedPrompts = user?.prompts?.prompts?.slice().sort((a, b) => b.id_prompt_user - a.id_prompt_user)
  }

  return (
    <React.Fragment>
      <div className={`${styles.myPromptsWrapper} ${className}`}>
        {title && (
          <div className={styles.titleSection}>
            {(block === 'myProfile' || user?.prompts?.prompts?.length >= 1) && (
              <h2 className={styles.sectionTitle}>{title}</h2>
            )}
          </div>
        )}

        <div className={styles.promptCardSection} ref={promptContainerRef}>
          {block === 'myProfile' && user?.prompts?.editable === 1 && (
            <PromptCard
              mode='add'
              className={styles.promptCardClassName}
              title={t('my_profile.myPrompts.newPrompt')}
              handleNewPrompt={handleNewPrompt}
            />
          )}
          {sortedPrompts?.length >= 1 &&
            sortedPrompts?.map((p, i) => {
              return (
                <PromptCard
                  key={i}
                  id={p.id_prompt}
                  promptOwner={user}
                  editable={user?.prompts?.editable === 1}
                  mode='view'
                  className={styles.promptCardClassName}
                  title={p?.prompt}
                  answer={p?.answer}
                  likes={p?.likes}
                  isLiked={
                    (user?.prompts?.editable === 1 && p.likes?.count > 0) ||
                    p?.likes?.users?.some((u) => u.id_user === loggedInUser?.id)
                  }
                  loading={loading && p.id_prompt === idInProcess}
                  handleLikeOrDislike={() => handleLikeOrDislike(p)}
                  handleComment={() => openReplyModal(p)}
                  handleEdit={() => handleEdit(p)}
                  handleDelete={() => handleDelete(p)}
                />
              )
            })}
        </div>
      </div>
      {isPromptModalOpen ? (
        <PromptListPopin
          isOpen={isPromptModalOpen}
          closeModal={closePromptModal}
          promptToEdit={selectedPrompt}
          action={actionPrompt}
        />
      ) : null}
      {isReplyModalOpen && selectedPrompt?.id_prompt > 0 ? (
        <Modal
          nested
          isOpen={isReplyModalOpen}
          handleClose={closeReplyModal}
          closeOnDocumentClick={true}
          className='replyPromptModal'>
          <PromptCard
            id={selectedPrompt.id_prompt}
            mode='reply'
            editable={false}
            promptOwner={user}
            className={`${styles.promptCardClassName} ${styles.replyPromptCard}`}
            title={selectedPrompt?.prompt}
            answer={selectedPrompt?.answer}
            likes={selectedPrompt?.likes}
            isLiked={
              (user?.prompts?.editable === 1 && selectedPrompt.likes?.count > 0) ||
              selectedPrompt?.likes?.users?.some((u) => u.id_user === loggedInUser?.id)
            }
            loading={loading && selectedPrompt.id_prompt === idInProcess}
            handleLikeOrDislike={() => handleLikeOrDislike(selectedPrompt)}
            handleComment={(message) => {
              handleComment(selectedPrompt, message)
              closeReplyModal()
            }}
          />
        </Modal>
      ) : null}
      {modalData.isShowUserModal ? (
        isMobileScreen() ? (
          <MobileModal
            isOpen={modalData.isShowUserModal}
            handleClose={closeLightModal}
            showDefaultHeader={false}
            closeOnDocumentClick={false}
            customContentStyle={{ height: '90%', padding: '0', border: '0', borderRadius: '2rem 2rem 0px 0px' }}
            className='messengerPromptPopup'>
            <MessengerMobile
              messageToSend={modalData.message}
              isMobile={true}
              isNative={isNative}
              fromFeed={true}
              userId={modalData.userId}
              closeMessengerPopup={closeLightModal}
            />
          </MobileModal>
        ) : (
          <Popup
            closeOnDocumentClick={false}
            open={modalData.isShowUserModal}
            onClose={closeLightModal}
            className='messengerPopup'
            contentStyle={{ borderRadius: '4rem' }}>
            <MessengerMobile
              fromFeed={true}
              messageToSend={modalData.message}
              userId={modalData.userId}
              closeMessengerPopup={closeLightModal}
            />
          </Popup>
        )
      ) : null}
    </React.Fragment>
  )
}
